import script from "./ImportProfilesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportProfilesView.vue?vue&type=script&setup=true&lang=ts"

import "./ImportProfilesView.vue?vue&type=style&index=0&id=7665af6d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7665af6d"]])

export default __exports__